import { useEffect } from 'react'
import { ELENCHI } from 'configuration/ConfigurazioneElenchi'
import ConfigManager from 'components/config/ConfigManager'
import { CHIAVI_ROUTES } from 'configuration/ConfigurazioneRotte'
import { FRONTOFFICE_HOME } from 'configuration/frontoffice'
import { LINK_SERVIZI } from 'configuration/link'
import Accesso from 'components/accesso/Accesso'
import { useVerbaliContext } from 'context/VerbaliProvider'
import FrontofficeContenitore from './FrontofficeContenitore'

const CFG = FRONTOFFICE_HOME
const CFG_SERVIZI = LINK_SERVIZI

export default function FrontofficeHome() {
  const { 
    salvaChiaveVerbale, 
    salvaVerbale, 
    setListaVerbali,
  } = useVerbaliContext()

  useEffect(() => {
    salvaVerbale(null)
    setListaVerbali(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ConfigManager
      elenchiConfig={[ELENCHI.CFG_FRONTOFFICE_HOME, ELENCHI.CFG_LINK_SERVIZI]}
      render={({ val }) =>
        <FrontofficeContenitore>
          <Accesso
            attivo={val(CFG_SERVIZI.FRONTOFFICE_ATTIVO)}
            spidAttivo={val(CFG.SPID_ATTIVO)}
            cieAttivo={val(CFG.CIE_ATTIVO)}
            chiaveWebAttivo={val(CFG.CHIAVE_WEB_ATTIVO)}
            propsChiaveWeb={{ salvaChiaveVerbale, salvaVerbale }}
            chiaveRottaDopoAccesso={CHIAVI_ROUTES.FRONTOFFICE_VERBALE}
          />
        </FrontofficeContenitore>
      }
    />
  )
}